export const trackingEventDictionary = {
  headerUserProfileProfileDetailsEdit: "header_user_profile_profile_details_edit",
  headerUserProfileProfileDetailsCancel: "header_user_profile_profile_details_cancel",
  headerUserProfileProfileDetailsUpdate: "header_user_profile_profile_details_update",
  headerUserProfileProfileDetailsSecurity: "header_user_profile_profile_details_security",
  headerUserProfileProfileDetailsSecurityChangePassword: "header_user_profile_profile_details_security_change_password",
  headerUserProfileProfileDetailsSecurityChangePasswordResetPassword: "header_user_profile_profile_details_security_change_password_reset_password",
  headerUserProfileProfileDetailsSecurityChangePasswordCancel: "header_user_profile_profile_details_security_change_password_cancel",
  headerUserProfileProfileDetails: "header_user_profile_profile_details",
  headerUserProfilePlanDetails: "header_user_profile_plan_details",
  headerUserProfileSignOut: "header_user_profile_sign_out",
  headerUserProfile: "header_user_profile",
  signInFromWebsite: "sign_in_from_website",
};
// export default trackingEventDictionary;
